export const getTrimmedString = (value: string | undefined) => {
  if (!value) return "";
  return value.trim();
};
